// ABOUTME: Custom multi-select dropdown with checkboxes and tag display
// ABOUTME: Enforces max 3 selections and handles "Other" text field toggle

import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["button", "dropdown", "checkbox", "otherField", "otherCheckbox"]

  connect() {
    this.maxSelections = 3
    this.updateButtonText()

    // Close dropdown when clicking outside
    this.boundHandleClickOutside = this.handleClickOutside.bind(this)
    document.addEventListener('click', this.boundHandleClickOutside)
  }

  disconnect() {
    document.removeEventListener('click', this.boundHandleClickOutside)
  }

  toggleDropdown(event) {
    event.stopPropagation()
    this.dropdownTarget.classList.toggle('hidden')
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.dropdownTarget.classList.add('hidden')
    }
  }

  checkboxChanged(event) {
    const checkbox = event.target
    const checkedCount = this.getCheckedCount()

    // Handle max selections
    if (checkedCount >= this.maxSelections) {
      this.disableUncheckedBoxes()
    } else {
      this.enableAllBoxes()
    }

    // Handle "Other" field visibility
    if (this.hasOtherCheckboxTarget && checkbox === this.otherCheckboxTarget) {
      this.toggleOtherField()
    }

    this.updateButtonText()
  }

  getCheckedCount() {
    return this.checkboxTargets.filter(cb => cb.checked).length
  }

  getCheckedValues() {
    return this.checkboxTargets
      .filter(cb => cb.checked)
      .map(cb => cb.value)
  }

  disableUncheckedBoxes() {
    this.checkboxTargets.forEach(cb => {
      if (!cb.checked) {
        cb.disabled = true
      }
    })
  }

  enableAllBoxes() {
    this.checkboxTargets.forEach(cb => {
      cb.disabled = false
    })
  }

  toggleOtherField() {
    if (this.hasOtherCheckboxTarget && this.hasOtherFieldTarget) {
      if (this.otherCheckboxTarget.checked) {
        this.otherFieldTarget.classList.remove('hidden')
        this.otherFieldTarget.querySelector('textarea').required = true
      } else {
        this.otherFieldTarget.classList.add('hidden')
        this.otherFieldTarget.querySelector('textarea').required = false
        this.otherFieldTarget.querySelector('textarea').value = ''
      }
    }
  }

  updateButtonText() {
    const count = this.getCheckedCount()
    const text = count === 0
      ? 'Select options'
      : `${count} selected`

    this.buttonTarget.querySelector('.selection-count').textContent = text
  }
}
